import { render, staticRenderFns } from "./RelateStore.vue?vue&type=template&id=150fb8bf"
import script from "./RelateStore.vue?vue&type=script&lang=js"
export * from "./RelateStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports